import {
  type KomboApplicationStageTransitionDefaultResponse,
  type KomboApplicationStageTransitionRequest,
} from "../api";
import { Utility } from "./utility";

export interface KomboApplicationStageTransitionDefault extends KomboApplicationStageTransitionDefaultResponse {
  get_local_time(time_string: string): Date;
}

export enum StageTransitionEvent {
  ASSESSED = "resume_assessment_is_completed",
  ASSESSED_NOT_SUITABLE = "resume_is_evaluated_as_not_suitable",
  ASSESSMENT_SKIPPED_OR_FAILED = "resume_assessment_is_skipped_or_failed",
  SCHEDULING = "moved_to_ai_scheduling",
  SCHEDULED = "scheduled",
  UNRESPONSIVE = "unresponsive_to_scheduling_for_5_days",
  WITHDRAWN = "withdrawn_before_phone_call",
  EVALUATED_HIGHLY_RECOMMEND = "evaluation_highly_recommend",
  EVALUATED_HIGHLY_RECOMMEND_CONDITIONAL = "evaluation_highly_recommend_conditional",
  EVALUATED_RECOMMEND = "evaluation_recommend",
  EVALUATED_RECOMMEND_CONDITIONAL = "evaluation_recommend_conditional",
  EVALUATED_NOT_RECOMMEND = "evaluation_not_recommend",
}

export class KomboApplicationStageTransitionDefault extends Utility<KomboApplicationStageTransitionDefault> {
  constructor(init?: Partial<KomboApplicationStageTransitionDefaultResponse>) {
    super();
    Object.assign(this, init);
  }

  get local_updated_at(): Date {
    return this.get_local_time(this.updated_at!);
  }

  toRequest(): KomboApplicationStageTransitionRequest {
    return {
      event: this.event as StageTransitionEvent,
      application_stage_id: this.application_stage_id ?? null,
      rejection_reason_id: this.rejection_reason_id ?? null,
    };
  }
}
